import {
    CameraCreationItem,
    CameraCreationStatus,
} from '@/types/source-creation';
import { getCameraCreationDrawerTitle } from '@/utils/camera';
import { StatusDrawerLayout } from './StatusDrawerLayout';
import { CameraSourceStatusDrawerItem } from './CameraSourceStatusDrawerItem';

interface CameraCreationDrawerContentProps {
    cameraItems: CameraCreationItem[];
    isExpanded: boolean;
    setExpanded: (val: boolean) => void;
    onClear: () => void;
}

export function CameraCreationDrawerContent({
    cameraItems,
    isExpanded,
    setExpanded,
    onClear,
}: CameraCreationDrawerContentProps) {
    const connectingCount = cameraItems.filter(
        (item) =>
            item.status === CameraCreationStatus.CREATING ||
            item.status === CameraCreationStatus.TESTING,
    ).length;
    const pendingCount = cameraItems.filter(
        (item) => item.status === CameraCreationStatus.PENDING,
    ).length;
    const completedCount = cameraItems.filter(
        (item) => item.status === CameraCreationStatus.COMPLETED,
    ).length;
    const errorCount = cameraItems.filter(
        (item) => item.status === CameraCreationStatus.ERROR,
    ).length;
    const totalCount = cameraItems.length;

    const hasActiveConnections = connectingCount > 0 || pendingCount > 0;
    const allComplete = !hasActiveConnections;

    const cameraTitle = getCameraCreationDrawerTitle(
        connectingCount,
        completedCount,
        errorCount,
        totalCount,
    );

    return (
        <StatusDrawerLayout
            title={cameraTitle}
            isExpanded={isExpanded}
            allComplete={allComplete}
            onToggleExpanded={() => setExpanded(!isExpanded)}
            onClose={onClear}
        >
            {cameraItems.map((item) => (
                <CameraSourceStatusDrawerItem key={item.id} item={item} />
            ))}
        </StatusDrawerLayout>
    );
}
